<template>
    <div class="coupon-item" :class="{'coupon-item-select': $attrs.bestTicketInfo && $attrs.bestTicketInfo.id === item.id,'coupon-item-disable': $attrs.tabName === 'cannotUse'}">
      <!-- <div
        v-if="$attrs.bestTicketInfo && ($attrs.bestTicketInfo.id === item.id)"
        class="check-coupon">
      </div> -->
      <!-- <img class="check-coupon-mark" src="https://fr-static.shopshops.top/20201225/selectTrue.380abd8cff796f4e.png" alt=""> -->
      <div class="coupon-item-content">
        <div class="left" v-if="item.ticket">
          <div class="money" :class="{ 'not-coupon': $attrs.tabName === 'cannotUse' }">
            <template v-if="
                (item.ticket.ticketType === 1 ||
                  item.ticket.ticketType === 3) &&
                  item.ticket.discountMoneyMoney
              ">
                <span class="symbol">{{
                  item.ticket.discountMoneyMoney.symbol
                }}</span>
                <span class="num">{{
                  item.ticket.discountMoneyMoney.number
                }}</span>
            </template>
            <template v-if="item.ticket.ticketType === 2">
              <template>
                <span class="num" v-if=" $i18n.locale === 'en' ">{{ (100-item.ticket.discountRate*100) }}</span>
                <span class="num" v-else>{{ item.ticket.discountRate * 10 }}</span>
                <span class="symbol">{{ $t("message.shop.coupon.discount") }}</span>
              </template>
              <!-- <template v-else>
                <span class="num">{{ 100 - item.ticket.discountRate * 100 }}</span>
                <span class="symbol">%</span>
              </template> -->
            </template>
          </div>
          <!-- <div
            class="condition"
            v-if="
              item.ticket.ticketType === 1 || item.ticket.ticketType === 2
            "
          >
            {{item.ticket.restrictMoneyMoney && $t("message.shop.coupon.canUse")}}{{
                item.ticket.restrictMoneyMoney && item.ticket.restrictMoneyMoney.number }}{{
                    item.ticket.restrictMoneyMoney && $t("message.shop.coupon.useMoney")}}
          </div>
          <div class="condition" v-if="item.ticket.ticketType === 3">
            {{ $t("message.shop.coupon.noThreshold") }}
          </div> -->
        </div>
        <div class="right">
          <div class="name">
            <!-- {{ item.ticket && item.ticket.ticketName }} -->
            {{item.ticket.restrictMoneyMoney && $t('message.shop.coupon.ordersOf')}}{{
              item.ticket.restrictMoneyMoney && item.ticket.restrictMoneyMoney.symbol }}{{
              item.ticket.restrictMoneyMoney && item.ticket.restrictMoneyMoney.number }}{{
                  item.ticket.restrictMoneyMoney && $t("message.shop.coupon.useMoney")}}
          </div>
          <div class="type">{{item.ticket && item.ticket.bindType && item.ticket.bindType.description}}</div>

          <div class="time" v-if="$i18n.locale === 'en'">{{item.expireTime && item.effectTime ? `Valid: ${changeTimer(item.effectTime)} - ${changeTimer(item.expireTime)}` : ''}}</div>
          <div class="time" v-else>
            {{item.expireTime? `到期时间: ${ $moment(new Date(item.expireTime)).format('YYYY-MM-DD HH:mm:ss') }` : ''}}
          </div>

        </div>
      </div>
    </div>
</template>
<script>
export default {
    props: {
        item: Object
    },
    data () {
        return {
        }
    },
    methods: {
        changeTimer(val) {
          return this.$moment(new Date(val)).format('MMM D, yyyy @h:mm a')
        }
    }
}
</script>
<style lang="less" scoped>
.coupon-item{
  width: 351px;
  height: 110px;
  margin: 12px auto;
  background: #fff;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  background: url(../../../assets/imgs/order/promo-normal.png) left top;
  background-size: 100% 100%;
  &-select{
    background: url(../../../assets/imgs/order/promo-select.png) left top;
    background-size: 100% 100%;
  }
  &-disable{
    background: url(../../../assets/imgs/order/promo-disable.png) left top;
    background-size: 100% 100%;
  }
  .coupon-item-content{
    display: flex;
    position: absolute;
    left: 0;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
  }
  .check-coupon{
    width: 35px;
    height: 35px;
    position: absolute;
    background: #F66355;
    right: 0;
    transform: rotate(90deg);
    &:after{
      content: '';
      display: block;
      position: absolute;
      border-bottom: 35px solid #ffffff;
      border-left: 35px solid transparent;
      border-right: 35px solid transparent;
      top: 1px;
    }
  }
  .check-coupon-mark{
    width: 16px;
    position: absolute;
    right: 20px;
    top: 40px;
  }
  .left {
    width: 99px;
    height: 110px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-right: 0.5px dotted #d0d0d0;
    padding-left: 38px;
    .money {
      color: #000000;
      line-height: 30px;
      .symbol {
        font-size: 13px;
      }
      .num {
        font-size: 32px;
      }
    }
    .not-coupon{
      color: #cccccc;
    }
    .condition {
      font-size: 10px;
      color: #666666;
    }
  }
  .right {
    text-align: left;
    /*align-items: center;*/
    padding: 18px 5px 10px 12px;
    div {
      font-size: 15px;
      color: #333333;
      line-height: 20px;
    }
    .name {
      font-size: 16px;
      font-family: TradeGothicLT-Bold, TradeGothicLT;
      font-weight: bold;
      color: #333333;
      line-height: 20px;
    }
    .type {
      margin-top: 6px;
      font-size: 12px;
      font-family: TradeGothicLT;
      color: #333333;
      line-height: 15px;
    }
    .time{
      margin-top: 14px;
      font-size: 10px;
      font-family: TradeGothicLT;
      color: #666666;
      line-height: 12px;
    }
  }
}
</style>